import PropTypes from 'prop-types';
import styled, { keyframes } from '@happymoneyinc/styled-components';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const Loader = props => {
  const {
    colorTheme,
    size,
    testID
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(LoaderContainer, {
      "data-testid": testID || 'loader',
      children: [/*#__PURE__*/jsx(Dot1, {
        $colorTheme: colorTheme,
        size: size
      }), /*#__PURE__*/jsx(Dot2, {
        $colorTheme: colorTheme,
        size: size
      }), /*#__PURE__*/jsx(Dot3, {
        $colorTheme: colorTheme,
        size: size
      })]
    })
  });
};
const LoaderContainer = styled.div`
  align-items: center;
  flex: 1;
  justify-content: center;
  display: flex;
  background-color: transparent;
`;
const loadDots = keyframes`
  0% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  50% {
    transform: translateY(-5px);
    opacity: 0;
  }

  100% {
    transform: translateY(-5px);
    opacity: 0;
  }
`;
const Dot = styled.span`
  width: ${_ref => {
  let {
    size
  } = _ref;
  return size === 'sm' ? '8px' : '16px';
}};
  height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === 'sm' ? '8px' : '16px';
}};
  margin: ${_ref3 => {
  let {
    size,
    theme
  } = _ref3;
  return size === 'md' ? theme.spacing[2] : theme.spacing[1];
}};
  background-color: ${_ref4 => {
  let {
    theme,
    $colorTheme
  } = _ref4;
  return $colorTheme === 'light' ? theme.colors.white : theme.colors.flamingo[1];
}};
  border-radius: 16px;
  animation: ${loadDots} 1.2s ease-in infinite;
  transition: all 0.2s ease-out;
`;
const Dot1 = styled(Dot)`
  animation-delay: 0s;
`;
const Dot2 = styled(Dot)`
  animation-delay: 0.2s;
`;
const Dot3 = styled(Dot)`
  animation-delay: 0.4s;
`;
Loader.defaultProps = {
  colorTheme: 'dark',
  size: 'md',
  testID: 'loader'
};
Loader.propTypes = {
  colorTheme: PropTypes.oneOf(['dark', 'light']),
  size: PropTypes.oneOf(['md', 'sm']),
  testID: PropTypes.string
};
var Loader$1 = Loader;

export { Loader$1 as default };
//# sourceMappingURL=Loader.js.map
